import React, {PureComponent, StrictMode} from "react";
import {Equipment} from "@App/types";
import {Checkbox} from "@App/Components/common/Checkbox";

type EquipmentListItemProps = {
    equipment: Equipment
    onClick: (equipment: Equipment) => void
}

export class EquipmentListItem extends PureComponent<EquipmentListItemProps> {
    render() {
        return (
            <StrictMode>
                <Checkbox
                    id={this.props.equipment.name}
                    title={this.props.equipment.name}
                    onChange={() => this.props.onClick(this.props.equipment)} />
            </StrictMode>
        );
    }
}
